import { defineTheme } from '@astryxdesign/core/theme';

const cache = new Map<string, ReturnType<typeof defineTheme>>();

/**
 * Dark studio theme. The accent is the only brand variable and comes from
 * the studio configuration (business.json -> database), so every studio is
 * re-skinned without touching code.
 */
export function studioTheme(accent: string) {
  const key = accent.toUpperCase();
  const hit = cache.get(key);
  if (hit) return hit;
  const theme = defineTheme({
    name: 'studio',
    color: { accent: [key, key], neutralStyle: 'cool', contrast: 'high' },
    typography: {
      scale: { base: 16, ratio: 1.2 },
      body: { family: 'Onest Variable', fallbacks: '-apple-system, "Segoe UI", Roboto, system-ui, sans-serif' },
      heading: { weight: 'semibold', weights: { 1: 'bold', 2: 'bold' } },
    },
    radius: { base: 6, multiplier: 1.5 },
    motion: { fast: 160, medium: 320, slow: 700, ratio: 0.75 },
    tokens: {
      '--color-accent': [key, key],
      '--color-on-accent': ['#FFFFFF', '#FFFFFF'],
      '--color-background-body': ['#000000', '#000000'],
      '--color-background-surface': ['#0D0E11', '#0D0E11'],
      '--color-background-card': ['#111318', '#111318'],
      '--color-background-popover': ['#16181E', '#16181E'],
      '--color-background-muted': ['#FFFFFF0F', '#FFFFFF0F'],
      '--color-text-primary': ['#F7F8FA', '#F7F8FA'],
      '--color-text-secondary': ['#A9B0BA', '#A9B0BA'],
      '--color-text-accent': [key, key],
      '--color-border': ['#FFFFFF1A', '#FFFFFF1A'],
      '--color-border-emphasized': ['#FFFFFF33', '#FFFFFF33'],
      '--focus-outline-color': 'var(--color-accent)',
      '--size-element-md': '40px',
      '--size-element-lg': '48px',
    },
    components: {
      button: {
        base: { borderRadius: 'var(--radius-full)', fontWeight: 'var(--font-weight-semibold)' },
      },
      card: {
        base: { borderRadius: 'var(--radius-container)' },
      },
    },
  });
  cache.set(key, theme);
  return theme;
}
